const dateRangePickerLocalization = {
  /** Accessible label for the trigger button that opens the range picker. */
  buttonLabel: 'Choose a date range',
  /** Placeholder shown in the trigger when no range is selected. */
  placeholder: 'Select a date range',
  /** Heading shown above the calendar in the popout (small viewports). */
  modalHeading: 'Choose a date range',
  /** Accessible label for the close button (small viewports). */
  closeLabel: 'Close window',
  /** Label for the button that commits the pending selection. */
  applyLabel: 'Apply',
  /** Label for the button that reverts to the last committed selection. */
  cancelLabel: 'Cancel',
  /** Label for the button that empties the selection. */
  clearLabel: 'Clear',
  /** Accessible label for the list of preset ranges. */
  presetsLabel: 'Date range presets',
  /** Label/accessible name for the collapsed preset dropdown on narrow widths. */
  presetsCollapsedLabel: 'Choose a preset',
  /** Joins the start and end of the displayed range, e.g. "1 Jan – 7 Jan". */
  rangeSeparator: '–',
  /** Error shown when the selected range starts before the minimum date. */
  dateOutOfMinBound: (minDate: string) => `Date must be on or after ${minDate}`,
  /** Error shown when the selected range ends after the maximum date. */
  dateOutOfMaxBound: (maxDate: string) => `Date must be on or before ${maxDate}`,

  // Preset labels.
  presetToday: 'Today',
  presetYesterday: 'Yesterday',
  presetLastDays: (days: number) => `Last ${days} days`,
  presetLastMonths: (months: number) => `Last ${months} months`,
  presetThisMonth: 'This month',
  presetLastWeek: 'Last week',
  presetLastMonth: 'Last month',
  presetLastQuarter: 'Last quarter',
  presetLastYear: 'Last year',
  presetCurrentWeek: 'Current week',
  presetCurrentMonth: 'Current month',
  presetCurrentQuarter: 'Current quarter',
  presetCurrentYear: 'Current year',
  /** Label for a specific calendar quarter, e.g. "Q3 2025". */
  presetQuarter: (quarter: number, year: number) => `Q${quarter} ${year}`,
}

export default dateRangePickerLocalization
